import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { IdentityServiceApi } from '../../../../api'

export const MUTATION = gql`
  mutation UploadDeviceCheckKey($input: DeviceCheckKeyInput!) {
    uploadDeviceCheckKey(input: $input) {
      success
    }
  }
`

export async function uploadDeviceCheckKey(
  client: ApolloClient<unknown>,
  input: IdentityServiceApi['DeviceCheckKeyInput'],
): Promise<boolean> {
  const response = await client.mutate({
    mutation: MUTATION,
    variables: { input },
  })

  return response.data.success
}
